var cov_3pz2lenil = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/zoom.ts",
      hash = "f061d0dd71cc693a1efb0b7bdde742b900d02fcf",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/zoom.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 33
        },
        end: {
          line: 1,
          column: 42
        }
      },
      "1": {
        start: {
          line: 3,
          column: 31
        },
        end: {
          line: 5,
          column: 1
        }
      },
      "2": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 4,
          column: 19
        }
      },
      "3": {
        start: {
          line: 6,
          column: 34
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "4": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 7,
          column: 22
        }
      },
      "5": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "6": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 13,
          column: 4
        }
      },
      "7": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 12
        }
      },
      "8": {
        start: {
          line: 16,
          column: 25
        },
        end: {
          line: 27,
          column: 1
        }
      },
      "9": {
        start: {
          line: 17,
          column: 13
        },
        end: {
          line: 17,
          column: 36
        }
      },
      "10": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 20,
          column: 3
        }
      },
      "11": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 16
        }
      },
      "12": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 26,
          column: 3
        }
      },
      "13": {
        start: {
          line: 22,
          column: 18
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "14": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 25,
          column: 5
        }
      },
      "15": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 72
        }
      },
      "16": {
        start: {
          line: 29,
          column: 0
        },
        end: {
          line: 29,
          column: 18
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 31
          },
          end: {
            line: 3,
            column: 32
          }
        },
        loc: {
          start: {
            line: 3,
            column: 54
          },
          end: {
            line: 5,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 6,
            column: 34
          },
          end: {
            line: 6,
            column: 35
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 10,
            column: 17
          },
          end: {
            line: 10,
            column: 18
          }
        },
        loc: {
          start: {
            line: 10,
            column: 37
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 10
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 11,
            column: 20
          },
          end: {
            line: 11,
            column: 21
          }
        },
        loc: {
          start: {
            line: 11,
            column: 26
          },
          end: {
            line: 13,
            column: 3
          }
        },
        line: 11
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 16,
            column: 25
          },
          end: {
            line: 16,
            column: 26
          }
        },
        loc: {
          start: {
            line: 16,
            column: 40
          },
          end: {
            line: 27,
            column: 1
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        }, {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        }, {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        }],
        line: 21
      },
      "2": {
        loc: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        }, {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        }],
        line: 23
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var listeners = (cov_3pz2lenil.s[0]++, new Set());
cov_3pz2lenil.s[1]++;
export var addZoomListener = function addZoomListener(cb) {
  cov_3pz2lenil.f[0]++;
  cov_3pz2lenil.s[2]++;
  listeners.add(cb);
};
cov_3pz2lenil.s[3]++;
export var removeZoomListener = function removeZoomListener(cb) {
  cov_3pz2lenil.f[1]++;
  cov_3pz2lenil.s[4]++;
  listeners["delete"](cb);
};
cov_3pz2lenil.s[5]++;

var dispatch = function dispatch(data) {
  cov_3pz2lenil.f[2]++;
  cov_3pz2lenil.s[6]++;
  listeners.forEach(function (cb) {
    cov_3pz2lenil.f[3]++;
    cov_3pz2lenil.s[7]++;
    cb(data);
  });
};

cov_3pz2lenil.s[8]++;

var updatePixelRatio = function updatePixelRatio(e) {
  cov_3pz2lenil.f[4]++;
  var pr = (cov_3pz2lenil.s[9]++, window.devicePixelRatio);
  cov_3pz2lenil.s[10]++;

  if (e) {
    cov_3pz2lenil.b[0][0]++;
    cov_3pz2lenil.s[11]++;
    dispatch(pr);
  } else {
    cov_3pz2lenil.b[0][1]++;
  }

  cov_3pz2lenil.s[12]++;

  if (window.matchMedia) {
    cov_3pz2lenil.b[1][0]++;
    var media = (cov_3pz2lenil.s[13]++, window.matchMedia("(resolution: ".concat(pr, "dppx)")));
    cov_3pz2lenil.s[14]++;

    if (media.addEventListener) {
      cov_3pz2lenil.b[2][0]++;
      cov_3pz2lenil.s[15]++;
      media.addEventListener('change', updatePixelRatio, {
        once: true
      });
    } else {
      cov_3pz2lenil.b[2][1]++;
    }
  } else {
    cov_3pz2lenil.b[1][1]++;
  }
};

cov_3pz2lenil.s[16]++;
updatePixelRatio();